import { gql, TypedDocumentNode } from '@apollo/client'

import { Data, Variables } from './types'

export const GET_SUPPLY_CHAIN: TypedDocumentNode<Data, Variables> = gql`
  query getSupplyChain($id: ID!) {
    node(id: $id) {
      ... on SupplyChain {
        id
        asi
        defaultSid
        name
      }
    }
  }
`
